import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SearchService {
  public resetSearchField = new Subject<boolean>();
}



// WEBPACK FOOTER //
// ./src/app/services/search.service.ts